<template>
  <div class="control-section">
    <div id="networkDiagram">
      <div id="diagram-space" class="sb-mobile-diagram">
        <ejs-diagram
          style="display: block"
          ref="diagramObj"
          id="diagram"
          :nodes="nodes"
          :getNodeDefaults="getNodeDefaults"
          :doubleClick="doubleClick"
          :selectionChange="selectionChange"
          :contextMenuSettings="contextMenuSettings"
          :contextMenuClick="contextMenuClick"
          :contextMenuOpen="contextMenuOpen"
          :width="width"
          :height="height"
          :constraints="diagramConstraints"
          :click="click"
          :positionChange="positionChange"
        >
          <!-- Begin dynamic Form -->
          <template>
            <FourListLinkagePanel
              :fourListLinkagePanel="fourListLinkagePanel"
              :roleNe="roleNe"
            ></FourListLinkagePanel>
          </template>

          <template>
            <ThreeListLinkagePanel
              :threeListLinkagePanel="threeListLinkagePanel"
            ></ThreeListLinkagePanel>
          </template>

          <template>
            <EquipmentInfoForm
              :equipmentInfoForm="equipmentInfoForm"
            ></EquipmentInfoForm>
          </template>
          <!-- END dynamic Form -->

          <!-- '网元图例展示' -->
          <template>
            <!--<NetTypeShow></NetTypeShow>-->
          </template>
          <!-- 面板信息展示 -->
          <template>
            <PanelBoardShow
              :alarmShowObj="alarmShowObj"
              :roleNe="roleNe"
            ></PanelBoardShow>
          </template>
          <template>
            <NePanelBoardShow
              :neAlarmShowObj="neAlarmShowObj"
            ></NePanelBoardShow>
          </template>
          <template>
            <TrunkPanelBoardShow
              :trunkShowObj="trunkShowObj"
            ></TrunkPanelBoardShow>
          </template>
          <template>
            <SubnetPanelBoardShow
              :subnetShowObj="subnetShowObj"
              :roleNe="roleNe"
            ></SubnetPanelBoardShow>
          </template>
          <template>
            <K8sServicePanel :k8sServiceShow="k8sServiceShow"></K8sServicePanel>
          </template>
          <template>
            <K8sNodePanel :k8sNodeShow="k8sNodeShow"></K8sNodePanel>
          </template>
        </ejs-diagram>
      </div>
    </div>
    <!-- 添加子网对话框 -->
    <CustomDialog
      ref="subnetDialog"
      :subNodes="nodesMap"
      :element="subnetDialog.element"
      :styles="subnetDialog.styles"
      :messages="subnetDialog.messages"
    >
      <template v-slot:dialog-content>
        <add-subnet ref="addsubnet" @close="cancelSubnet"></add-subnet>
      </template>
    </CustomDialog>
    <!-- 修改子网弹框 -->
    <CustomDialog
      ref="updateSubnetDialog"
      :subNodes="nodesMap"
      :element="upSubnetDialog.element"
      :styles="upSubnetDialog.styles"
      :messages="upSubnetDialog.messages"
    >
      <template v-slot:dialog-content>
        <update-subnet
          ref="updateSubnet"
          @close="cancel2Subnet"
        ></update-subnet>
      </template>
    </CustomDialog>
  </div>
</template>
<style></style>

<script>
import Vue from "vue";
import {
  Node,
  DiagramPlugin,
  SymbolPalettePlugin,
  Diagram,
  SnapConstraints,
  NodeConstraints,
  DiagramContextMenu,
  AnnotationConstraints,
  DiagramConstraints
} from "@syncfusion/ej2-vue-diagrams";

import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { createNamespacedHelpers } from "vuex";
import CustomDialog from "../common/CustomDialog";

import NetTypeShow from "./NetTypeShow";
import PanelBoardShow from "./PanelBoardShow";
import NePanelBoardShow from "./NePanelBoardShow";
import TrunkPanelBoardShow from "./TrunkPanelBoardShow";
import SubnetPanelBoardShow from "./SubnetPanelBoardShow";
import K8sServicePanel from "./K8sServicePanel";
import K8sNodePanel from "./K8sNodePanel";
import AddSubnet from "./AddSubnet";
import UpdateSubnet from "./UpdateSubnet";

//-- Begin Dynamic panel
import FourListLinkagePanel from "./FourListLinkagePanel";
import ThreeListLinkagePanel from "./ThreeListLinkagePanel";
import EquipmentInfoForm from "./EquipmentInfoForm";
//-- END Dynamic panel

import topoMethods from "./TopoCommon";
import socketInstance from "../../plugins/stompSock";
import { EventBus } from "../../plugins/eventBus";

const { mapGetters, mapActions } = createNamespacedHelpers("topoConfig");

Diagram.Inject(DiagramContextMenu);
Vue.use(DiagramPlugin);
Vue.use(SymbolPalettePlugin);
Vue.use(UploaderPlugin);
Vue.use(ButtonPlugin);

let diagramInstance;

export default {
  name: "base-physic",
  components: {
    CustomDialog,
    PanelBoardShow,
    NePanelBoardShow,
    TrunkPanelBoardShow,
    SubnetPanelBoardShow,
    K8sServicePanel,
    K8sNodePanel,
    NetTypeShow,
    AddSubnet,
    UpdateSubnet,

    //-- Begin Dynamic Panel
    FourListLinkagePanel,
    ThreeListLinkagePanel,
    EquipmentInfoForm,
    //-- End Dynamic Panel
  },
  created() {
    this.loadElement();

    //-- Net element type / equipment type
    this.getAllNetTypeList();
    this.getAllEquipmentTypeList();
    this.queryAlarmTimer = setInterval(this.queryAlarm, 10000);
  },
  beforeDestroy() {
    if (this.queryAlarmTimer) {
      clearInterval(this.queryAlarmTimer);
      this.queryAlarmTimer = null;
    }
    if (this.findAlarmTimer) {
      clearTimeout(this.findAlarmTimer);
      this.findAlarmTimer = null;
    }
    socketInstance.stopReceiveTopicMsg2(
      this.payload[0].clientId,
      this.payload[0].topic
    );
  },
  //-- when page destroyed execute
  destroyed: function () {
    socketInstance.stopReceiveTopicMsg2("topo", "/topic/ElementServer");
  },
  mixins: [topoMethods],
  props: ["dataSource", "graphType", "roleNe"],
  watch: {},
  data() {
    return {
      isLogical: true, // 逻辑视图
      isAdd: false, // 添加或修改元素
      diagramConstraints: DiagramConstraints.Default | DiagramConstraints.Virtualization, // 开启虚拟化列表（默认渲染窗口展示的数据）
      alarmMap: new Map(),
      fourListLinkagePanel: {
        seeObj: true,
        seeBottomObj: true,
        idObj: "",
        parentId: "",
        typeObj: "",
        onlineObj: "",
        serviceName: "",
        typeCode: "",
        icon: "",
        PositionXY: "",
        postUrl: "",
      },
      threeListLinkagePanel: {
        seeObj: true,
        seeBottomObj: true,
        idObj: "",
        parentId: "",
        typeObj: "",
        onlineObj: "",
        serviceName: "",
        typeCode: "",
        icon: "",
        PositionXY: "",
        postUrl: "",
      },
      equipmentInfoForm: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        parentId: "",
        typeObj: "",
        onlineObj: "",
        serviceName: "",
        typeCode: "",
        icon: "",
        PositionXY: "",
        postUrl: "",
        nameKey: "",
      },

      alarmShowObj: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        typeObj: "",
        onlineObj: "",
        PositionXY: "",
      },
      neAlarmShowObj: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        typeObj: "",
        onlineObj: "",
        PositionXY: "",
      },
      trunkShowObj: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        typeObj: "",
        onlineObj: "",
        PositionXY: "",
      },
      subnetShowObj: {
        seeObj: true,
        seeBottomObj: true,
        idObj: "",
        onlineObj: "",
        PositionXY: "",
      },
      k8sServiceShow: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        parentId: "",
        typeObj: "",
        onlineObj: "",
        serviceName: "",
        PositionXY: "",
      },
      k8sNodeShow: {
        seeObj: false,
        seeBottomObj: false,
        idObj: "",
        parentId: "",
        typeObj: "",
        onlineObj: "",
        PositionXY: "",
      },

      leftDataSource: [], //-- left-topo data, when left data change and this change
      dClickId: null, // 双击设备或子网缓存id
      dClickPId: null, // 双击设备或子网缓存parentId
      successMsg: this.$t("Track.success"),
      nodeName: "",
      nodeId: "",
      width: "100%",
      height: "calc(100vh - 140px)",
      see: false,
      seeBottom: false,
      selectNe: "",
      showNetType: false,
      constraints:
        (NodeConstraints.Default &
          ~NodeConstraints.Rotate &
          ~NodeConstraints.Resize) |
        NodeConstraints.HideThumbs |
        NodeConstraints.Tooltip,
      offsetX: 0,
      offsetY: 0,
      deleteNodeId: 0,
      deleteNodeType: 0,
      findAlarmTimer: null,
      queryAlarmTimer: null,
      netTypeList: [],
      equipmentTypeList: [],
      selectNodes: [],
      reflreshFlag: true,
      alarmHeight: 78,
      nodesMapView: new Map(),
      getNodeDefaults: (node, diagram) => {
        node.height =
          node.alarmCount > 0 && node.isOnline ? this.alarmHeight : 58;
        node.width = 58;
        return node;
      },
      contextMenuSettings: {
        show: true,
        items: this.menuList(),
        showCustomMenuOnly: true,
      },
      contextMenuOpen: (args) => {
        // 保存坐标
        this.offsetX =
          args.event && args.event.offsetX ? args.event.offsetX : 256;
        this.offsetY =
          args.event && args.event.offsetY ? args.event.offsetY : 256;
        const childList = args.element.querySelectorAll("li.e-menu-item");
        const node = diagramInstance.selectedItems.nodes[0];
        console.log("******diagramInstance.selectedItems.nodes:", diagramInstance.selectedItems.nodes)
        console.log("******node:", node)
        let array = [];
        // 右击空白
        if (node === undefined) {
          var containSubnet = false;
          for (let i = 0; i < this.nodes.length; i++) {
            if (isNaN(this.nodes[i].type) || this.nodes[i].type == 0) {
              containSubnet = true;
              break;
            }
          }

          const num = this.nodes.length;
          if (containSubnet == true) {
            //-- when has subnet allow add
            array = ["block", "none", "none"];
            for (let i = 0; i < childList.length; i++)
              childList[i].style.display = array[i];

            return;
          }

          /**
					     		获取当前层网元个数, less than 2 element do not add
				         		duanbaoming: 子网下只能加 环境和其他子网 我猜是想判断这个得
					     		can add subnet , for example : 1、 30001 ~ 30010 ; 2、 0 ; 3、 10004 ~ 10009
					     */
          let currentNodeNum = 0;
          for (let i = 0; i < this.nodes.length; i++) {
            if (
              isNaN(this.nodes[i].type) ||
              this.nodes[i].type == 0 ||
              (Number(this.nodes[i].type) >= 10004 &&
                Number(this.nodes[i].type) <= 10009) ||
              (Number(this.nodes[i].type) >= 30001 &&
                Number(this.nodes[i].type) <= 30010)
            ) {
              currentNodeNum++;
            }
            if (currentNodeNum >= 1) {
              //-- when has two enviroment
              array = ["block", "none", "none"];
              for (let i = 0; i < childList.length; i++)
                childList[i].style.display = array[i];

              return;
            }
          }

          //-- else cancel
          args.cancel = true;
          return;
        } else if (diagramInstance.selectedItems.nodes.length > 1) {
          //-- 多选时右击不显示菜单     , else cancel
          args.cancel = true;
          return;
        } else if (diagramInstance.selectedItems.nodes.length == 1) {
          //-- 右击节点
          if (node.type == 0) {
            array = ["none", "block", "block"];
            array.forEach((value, index) => {
              childList[index].style.display = array[index];
            });
            return;
          }

          //-- else cancel
          args.cancel = true;
          return;
        }
      },
      contextMenuClick: (args) => {
        // 右击网元或空白
        const selectedNode = diagramInstance.selectedItems.nodes[0];
        console.log("******selectedNode:", selectedNode)
        // 权限控制如果是Eadmin账户有任何权限
        let username = "";
        let principal = sessionStorage.getItem("principal");
        if (!!principal) {
          let user = JSON.parse(principal);
          username = user.username;
        }

        // 添加子网, 设备, 网元
        if (selectedNode === undefined) {
          if (args.item.id != "addSubnet") return;

          let netNodes = [];
          for (var i = 0; i < diagramInstance.nodes.length; i++)
            netNodes.push(diagramInstance.nodes[i]);

          //-- get has auth netElement
          this.getAuth2(username, netNodes).then((result) => {
            if (result.success == false || result.authNetId.length == 0) {
              EventBus.$emit("toast", {
                type: "warning",
                content: this.$t("Topo.permissionDenied"),
              });
              return;
            }

            this.isAdd = true;
            const pId = diagramInstance.nodes[0].parentid;
            const currentNodes = new Array();

            for (var j = 0; j < diagramInstance.nodes.length; j++) {
              var hasPermis = result.authNetId.find(
                (id) => id == diagramInstance.nodes[j].id
              );
              if (hasPermis) {
                //-- when has auth netElement
                currentNodes.push(diagramInstance.nodes[j]);
              }
            }

            this.$refs.addsubnet.initData(
              this.getPhysicalById(pId),
              currentNodes
            );
            this.$refs.addsubnet.bindValidate();
            this.$refs.subnetDialog.show();
          });
        } else {
          switch (args.item.id) {
            case "editSubnet":
              this.isAdd = false;
              let netNodes = [];
              for (var i = 0; i < diagramInstance.nodes.length; i++)
                netNodes.push(diagramInstance.nodes[i]);

              //-- get has auth netElement
              this.getAuth2(username, netNodes).then((result) => {
                this.axios
                  .get(`/lte/ems/topo/subnet/findSubnet/${selectedNode.id}`)
                  .then((response) => {
                    if (
                      (response && response.status !== 200) ||
                      response.data.errorCode !== "SUCCESS"
                    )
                      return;

                    if (response.data.errorString) {
                      EventBus.$emit("toast", {
                        type: "error",
                        content: response.data.errorString,
                      });
                      return;
                    }
                    const currentNodes = new Array();
                    for (var j = 0; j < diagramInstance.nodes.length; j++) {
                      var hasPermis = result.authNetId.find(
                        (id) => id == diagramInstance.nodes[j].id
                      );
                      if (hasPermis) {
                        //-- when has auth netElement
                        currentNodes.push(diagramInstance.nodes[j]);
                      }
                    }
                    const subnetInfo = response.data.resultVal;
                    this.$refs.updateSubnet.initData(
                      "update",
                      subnetInfo,
                      currentNodes
                    );
                    this.$refs.updateSubnet.bindValidate();
                    this.$refs.updateSubnetDialog.show();
                  });
              });

              break;

            case "delSubnet":
            case "delTrunk":
            case "delDevice":
            case "delNe":
              if (selectedNode && selectedNode.type !== undefined) {
                // 删除参数id, type
                this.deleteNodeId = selectedNode.id;
                this.deleteNodeType = selectedNode.type;
                this.$layer.confirm({
                  msg: this.$t("MCS.deleteConfirm"),
                  btn1: {
                    msg: this.$t("System.cancel"),
                  },
                  btn2: {
                    msg: this.$t("System.confirm"),
                    func: this.deleteNe,
                  },
                });
              } else {
                console.log("网元或类型为空");
              }
              break;
          }
        }
      },
      pageSettings: {
        margin: { top: 10, left: 0, right: 0, bottom: 0 },
        // width: this.pageRowLength,
        // height: this.pageColumnLength,
        width: document.body.clientWidth - 300,
        height: 12000,
        // orientation: 'Portrait',
        showPageBreaks: false,
        // multiplePage: true,
        boundaryConstraints: "Page", //Diagram
      },
      snapSettings: { constraints: SnapConstraints.None }, // 网格
      element: {
        // target: '#app',
        refName: "add",
        isClose: true,
      },
      scrollSettings: {
        canAutoScroll: false,
        scrollLimit: "Diagram",
        horizontalOffset: 0,
        verticalOffset: 0,
        currentZoom: 1,
        maxZoom: 1.2,
        minZoom: 0.1,
      },
      selectionChange: (args) => {
        try {
          if (args.type === "Addition" && args.state === "Changed") {
            if (args.newValue && args.newValue.length === 1) {
              this.selectNodes.push(args.newValue[0]);
            } else {
              this.selectNodes = args.newValue;
            }
          }
        } catch (e) {
          console.log(e);
        }

        if (args.state === "Changing") {
          this.alarmShowObj.seeObj = false;
          this.alarmShowObj.seeBottomObj = false;
          this.neAlarmShowObj.seeObj = false;
          this.neAlarmShowObj.seeBottomObj = false;
          this.trunkShowObj.seeObj = false;
          this.trunkShowObj.seeBottomObj = false;
          this.subnetShowObj.seeObj = false;
          this.subnetShowObj.seeBottomObj = false;
          this.k8sServiceShow.seeObj = false;
          this.k8sNodeShow.seeObj = false;

          //-- Dynamic panel
          this.fourListLinkagePanel.seeObj = false;
          this.fourListLinkagePanel.seeBottomObj = false;
          this.threeListLinkagePanel.seeObj = false;
          this.equipmentInfoForm.seeObj = false;
          return;
        }

        if (
          args.type === "Addition" &&
          args.state === "Changed" &&
          args.newValue.length === 1
        ) {
          const node =
            diagramInstance.nodes[
              diagramInstance.nodes.findIndex(
                (v) => v.id === args.newValue[0].id
              )
            ];

          const selectNode = []; // 选中网元
          if (args.newValue instanceof Array && args.newValue.length > 0) {
            selectNode.push(node);
          }

          //-- Begin Dynamic load pannel, when has findNodeType
          var allNetType = this.getAllNetTypeList();
          var dynamicNodeTypeList = allNetType.filter(
            (x) =>
              x.typeCode == Number(node.type) &&
              x.useVue != undefined &&
              x.useVue != null
          );

          if (dynamicNodeTypeList != null && dynamicNodeTypeList.length > 0) {
            var dynamicNodeType = dynamicNodeTypeList[0];
            //-- ThreeTypeForms
            if (dynamicNodeType.useVue == "FourListLinkagePanel") {
              //-- 0.set node value, when node value use on popositionChange
              node.PositionX = 800;
              node.PositionY = 600;
              node.useVue = "FourListLinkagePanel";
              node.postUrl = dynamicNodeType.postUrl;

              //-- 1.set the vue value
              this.fourListLinkagePanel.seeObj = true;
              this.fourListLinkagePanel.seeBottomObj = true;
              this.fourListLinkagePanel.idObj = node.id;
              this.fourListLinkagePanel.parentId = node.parentid;
              this.fourListLinkagePanel.typeObj = node.type;
              this.fourListLinkagePanel.onlineObj = node.isOnline;
              this.fourListLinkagePanel.typeCode = dynamicNodeType.typeCode;
              this.fourListLinkagePanel.icon = dynamicNodeType.icon;
              this.fourListLinkagePanel.postUrl = dynamicNodeType.postUrl;
              this.fourListLinkagePanel.serviceName = node.name;

              if (
                args.newValue[0].offsetX >=
                  document.body.clientWidth - node.PositionX &&
                args.newValue[0].offsetY <= node.PositionY
              )
                this.fourListLinkagePanel.PositionXY = "left:25px";
              else this.fourListLinkagePanel.PositionXY = "right:25px";

              return;
            }
          }
          //-- END Dynamic load pannel, when has findNodeType

          //-- equipment type
          var equipmentTypeList = this.getAllEquipmentTypeList();
          var dynamicEquipmentTypeList = equipmentTypeList.filter(
            (x) =>
              x.typeCode == Number(node.type) &&
              x.useVue != undefined &&
              x.useVue != null
          );

          if (
            dynamicEquipmentTypeList != null &&
            dynamicEquipmentTypeList.length > 0
          ) {
            var dynamicNodeType = dynamicEquipmentTypeList[0];
            //-- ThreeTypeForms
            if (dynamicNodeType.useVue == "ThreeListLinkagePanel") {
              //-- 0.set node value, when node value use on popositionChange
              node.PositionX = 800;
              node.PositionY = 600;
              node.useVue = "ThreeListLinkagePanel";
              node.postUrl = dynamicNodeType.postUrl;

              //-- 1.set the vue value
              this.threeListLinkagePanel.seeObj = true;
              this.threeListLinkagePanel.seeBottomObj = true;
              this.threeListLinkagePanel.idObj = node.id;
              this.threeListLinkagePanel.parentId = node.parentid;
              this.threeListLinkagePanel.typeObj = node.type;
              this.threeListLinkagePanel.onlineObj = node.isOnline;
              this.threeListLinkagePanel.typeCode = dynamicNodeType.typeCode;
              this.threeListLinkagePanel.icon = dynamicNodeType.icon;
              this.threeListLinkagePanel.postUrl = dynamicNodeType.postUrl;
              this.threeListLinkagePanel.serviceName = node.name;

              if (
                args.newValue[0].offsetX >=
                  document.body.clientWidth - node.PositionX &&
                args.newValue[0].offsetY <= node.PositionY
              )
                this.threeListLinkagePanel.PositionXY = "left:25px";
              else this.threeListLinkagePanel.PositionXY = "right:25px";

              return;
            }

            //-- EquipmentInfoForm
            if (dynamicNodeType.useVue == "EquipmentInfoForm") {
              //-- 0.set node value, when node value use on popositionChange
              node.PositionX = 700;
              node.PositionY = 400;
              node.useVue = "EquipmentInfoForm";
              node.postUrl = dynamicNodeType.postUrl;

              //-- 1.set the vue value
              this.equipmentInfoForm.seeObj = true;
              this.equipmentInfoForm.idObj = node.id;
              this.equipmentInfoForm.parentId = node.parentid;
              this.equipmentInfoForm.typeObj = node.type;
              this.equipmentInfoForm.nameKey = dynamicNodeType.nameKey;
              this.equipmentInfoForm.onlineObj = node.isOnline;
              this.equipmentInfoForm.typeCode = dynamicNodeType.typeCode;
              this.equipmentInfoForm.icon = dynamicNodeType.icon;
              this.equipmentInfoForm.postUrl = dynamicNodeType.postUrl;
              this.equipmentInfoForm.serviceName = node.name;

              if (
                args.newValue[0].offsetX >=
                  document.body.clientWidth - node.PositionX &&
                args.newValue[0].offsetY <= node.PositionY
              )
                this.equipmentInfoForm.PositionXY = "left:25px";
              else this.equipmentInfoForm.PositionXY = "right:25px";

              return;
            }
          }

          this.nodeId = node.id.substring(1, args.newValue[0].id.length);
          if (
            (Number(node.type) > 1 && Number(node.type) < 36) ||
            (Number(node.type) > 43 && Number(node.type) < 1000)
          ) {
            this.neAlarmShowObj.seeObj = true;
            this.neAlarmShowObj.seeBottomObj = true;
            this.neAlarmShowObj.idObj = node.id;
            this.neAlarmShowObj.typeObj = node.type;
            this.neAlarmShowObj.onlineObj = node.isOnline;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - (470 + 325) &&
              args.newValue[0].offsetY <= 630
            )
              this.neAlarmShowObj.PositionXY = "left:25px";
            else this.neAlarmShowObj.PositionXY = "right:25px";

            return;
          } else if (Number(node.type) >= 36 && Number(node.type) <= 43) {
            //-- NetElement 5GC(Product)
            this.k8sServiceShow.seeObj = true;
            this.k8sServiceShow.seeBottomObj = true;
            this.k8sServiceShow.idObj = node.id;
            this.k8sServiceShow.parentId = node.parentid;
            this.k8sServiceShow.typeObj = node.type;
            this.k8sServiceShow.onlineObj = node.isOnline;
            this.k8sServiceShow.serviceName = node.name;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - (470 + 325) &&
              args.newValue[0].offsetY <= 630
            )
              this.k8sServiceShow.PositionXY = "left:25px";
            else this.k8sServiceShow.PositionXY = "right:25px";

            return;
          } else if (Number(node.type) >= 1000 && Number(node.type) <= 1010) {
            //-- NetElement 5GC(Product)
            this.k8sServiceShow.seeObj = true;
            this.k8sServiceShow.seeBottomObj = true;
            this.k8sServiceShow.idObj = node.id;
            this.k8sServiceShow.parentId = node.parentid;
            this.k8sServiceShow.typeObj = node.type;
            this.k8sServiceShow.onlineObj = node.isOnline;
            this.k8sServiceShow.serviceName = node.name;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - (470 + 325) &&
              args.newValue[0].offsetY <= 630
            )
              this.k8sServiceShow.PositionXY = "left:25px";
            else this.k8sServiceShow.PositionXY = "right:25px";

            return;
          } else if (node.type >= 10001 && node.type < 11000) {
            //-- 0.set node value, when node value use on popositionChange
            node.PositionX = 675;
            node.PositionY = 370;

            //-- 1. set property
            this.alarmShowObj.seeObj = true;
            this.alarmShowObj.seeBottomObj = true;
            this.alarmShowObj.idObj = node.id;
            this.alarmShowObj.typeObj = node.type;
            this.alarmShowObj.onlineObj = node.isOnline;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - node.PositionX &&
              args.newValue[0].offsetY <= node.PositionY
            )
              this.alarmShowObj.PositionXY = "left:25px";
            else this.alarmShowObj.PositionXY = "right:25px";

            return;
          } else if (Number(node.type) >= 12001 && Number(node.type) <= 12003) {
            //-- Device type mono_master/mono_slave/5gc
            this.k8sNodeShow.seeObj = true;
            this.k8sNodeShow.seeBottomObj = true;
            this.k8sNodeShow.idObj = node.id;
            this.k8sNodeShow.parentId = node.parentid;
            this.k8sNodeShow.typeObj = node.type;
            this.k8sNodeShow.onlineObj = node.isOnline;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - (470 + 325) &&
              args.newValue[0].offsetY <= 640
            )
              this.k8sNodeShow.PositionXY = "left:25px";
            else this.k8sNodeShow.PositionXY = "right:25px";

            return;
          } else if (Number(node.type) >= 20100 && Number(node.type) <= 20165) {
            //-- trunk node show
            this.trunkShowObj.seeObj = true;
            this.trunkShowObj.seeBottomObj = true;
            this.trunkShowObj.idObj = node.id;
            this.trunkShowObj.typeObj = node.type;
            this.trunkShowObj.onlineObj = node.isOnline;

            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - (350 + 325) &&
              args.newValue[0].offsetY <= 370
            )
              this.trunkShowObj.PositionXY = "left:25px";
            else this.trunkShowObj.PositionXY = "right:25px";

            return;
          } else if (Number(node.type) == 0) {
            ///-- 0.set node value, when node value use on popositionChange
            node.PositionX = 675;
            node.PositionY = 370;

            //-- 1. set property
            this.subnetShowObj.seeObj = true;
            this.subnetShowObj.seeBottomObj = true;
            this.subnetShowObj.idObj = node.id;
            this.subnetShowObj.onlineObj = node.isOnline;
            if (
              args.newValue[0].offsetX >=
                document.body.clientWidth - node.PositionX &&
              args.newValue[0].offsetY <= node.PositionY
            )
              this.subnetShowObj.PositionXY = "left:25px";
            else this.subnetShowObj.PositionXY = "right:25px";
          }
        }
      },
      // 添加子网对话框
      subnetDialog: {
        element: {
          title: this.$t("Topo.addSubnet"),
          // target: '#app',
          isClose: true,
          refName: this.$t("Topo.subnetMan"),
          buttonGroup: [
            {
              click: this.cancelSubnet,
              buttonModel: { content: this.$t("Topo.cancel") },
            },
            {
              click: this.addSubnet,
              buttonModel: { content: this.$t("Topo.ok"), isPrimary: true },
            },
          ],
        },
        styles: {
          width: "780px",
          height: "660px",
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t("Topo.addSubnet"),
        },
      },
      // 修改子网对话框
      upSubnetDialog: {
        element: {
          title: this.$t("Topo.updateSubnet"),
          // target: '#app',
          isClose: true,
          refName: this.$t("Topo.subnetMan"),
          buttonGroup: [
            {
              click: this.cancel2Subnet,
              buttonModel: { content: this.$t("Topo.cancel") },
            },
            {
              click: this.update2Subnet,
              buttonModel: { content: this.$t("Topo.ok"), isPrimary: true },
            },
          ],
        },
        styles: {
          width: "800px",
          height: "720px",
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t("Topo.updateSubnet"),
        },
      },

      payload: [
        {
          topic: "/topic/ElementServer",
          clientId: "topo",
          callback: this.subscribeCallback,
        },
      ],
    };
  },
  mounted() {
    socketInstance.init(this.payload);
    diagramInstance = this.$refs.diagramObj.ej2Instances;
    delete diagramInstance.commands.delete;
    delete diagramInstance.commands.copy;
    delete diagramInstance.commands.paste;
    delete diagramInstance.commands.cut;
  },
  computed: {
    ...mapGetters([
      "physicalNodes",
      "logicalNodes",
      "getParentNe",
      "getTypeByCode",
    ]),
  },
  methods: {
    ...mapActions([
      "setPhysical",
      "addPhysical",
      "delPhysicalNodes",
      "setParentNe",
    ]),
    // 加载网元
    async loadElement() {
      await this.loadGraph(this.isLogical);
      // this.findAlarmTimer = setTimeout(this.queryAlarm, 2000);
    },
    // 首次加载物理/逻辑视图, 并将网元放入缓存
    async loadGraph(isLogical) {
      const This = this;
      if (isLogical === undefined) {
        isLogical = this.isLogical;
      } else {
        this.isLogical = isLogical;
      }

      this.nodes = [];
      const nodesMap = new Map();
      nodesMap.clear();
      this.nodesMapView.clear();
      let url = "/lte/ems/topo/logicalView";
      if (!isLogical) {
        url = "/lte/ems/topo/physicalView";
      }
      const dataSource = [];
      try {
        await this.queryAlarmApi();
        const topoViewResult = await this.axios.post(url);
        if (
          topoViewResult &&
          topoViewResult.status === 200 &&
          topoViewResult.data.errorCode === "SUCCESS"
        ) {
          topoViewResult.data.resultVal.forEach((element) => {
            const node = this.createElement(element);
            // 判断是否属于报警数据
            const id = node.id;
            const currentAlarmItem = this.alarmMap.get(id);
            if (currentAlarmItem) {
              this.setAlarmStatus(id, currentAlarmItem.level, currentAlarmItem.count, node);
            } else {
              this.setAlarmStatus(id, -1, 0, node);
            }
            // 填充nodes
            if (
              node.parentid === 0 ||
              node.parentid === "" ||
              node.parentid === null ||
              node.parentid === undefined
            ) {
              dataSource.push(node);
            }
            nodesMap.set(node.id, node);
            this.nodesMapView.set(node.id, node);
          });
          //console.log("================nodesMapView",this.nodesMapView)
          EventBus.$emit("nodesMapView", this.nodesMapView);

          This.nodes = dataSource;
          if (nodesMap.size > 0) {
            This.setPhysical([]);
            This.setPhysical(nodesMap);
          }
        }
        this.$loading.hideLoadding();
      } catch(e) {
        console.log('初始化数据失败=====>', e)
      }
    },
    getAllNetTypeList() {
      //-- All  NetElement type list
      if (this.netTypeList != null && this.netTypeList.length > 0) {
        return this.netTypeList;
      }
      //-- 获取网元类型信息
      var This = this;
      this.axios.post("/lte/ems/topo/ne/allNetTypeList").then((response) => {
        if (
          response &&
          response.status === 200 &&
          response.data.errorCode === "SUCCESS"
        ) {
          This.netTypeList = response.data.resultVal;
        }
      });
      return this.netTypeList;
    },
    getAllEquipmentTypeList() {
      //-- All Equipment type list
      if (this.equipmentTypeList != null && this.equipmentTypeList.length > 0) {
        return this.equipmentTypeList;
      }
      //-- 获取网元类型信息
      var This = this;
      this.axios
        .post("/lte/ems/topo/ne/allEquipmentTypeList")
        .then((response) => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            This.equipmentTypeList = response.data.resultVal;
          }
        });
      return this.equipmentTypeList;
    },
    // 给拓扑树发送当前选中网元id
    sendMessage(NeID) {
      //console.log('ggNeID2', NeID);
      this.$emit("sendInfo", NeID);
    },

    isShowSubnetMenu() {
      const nodes = diagramInstance.nodes;
      if (!nodes) return false;
      let num = 0;
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].type === 0 || nodes[i].type >= 10000) {
          num++;
          if (num >= 2) {
            return true;
          }
        }
      }
      return false;
    },
    deleteNe() {
      const neId = this.deleteNodeId;
      const type = this.deleteNodeType;
      const param = { id: neId };
      if (type == undefined || type != 0) return;

      this.axios
        .get(`/lte/ems/env/topo/subnet/findSubnet/${neId}`)
        .then((response) => {
          let subnetInfo;
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            subnetInfo = response.data.resultVal;
          } else {
            subnetInfo = param;
          }

          this.axios
            .post("/lte/ems/env/topo/subnet/deleteSubnet", { ...subnetInfo })
            .then((response) => {
              if (
                response &&
                response.status === 200 &&
                response.data.errorCode === "SUCCESS"
              ) {
                diagramInstance.remove(diagramInstance.nodes[neId]);
                this.delPhysicalNodes(neId);
                EventBus.$emit("toast", {
                  type: "success",
                  content: this.successMsg,
                });
              } else {
                if (response.data.errorString) {
                  EventBus.$emit("toast", {
                    type: "error",
                    content: response.data.errorString,
                  });
                }
              }
            });
        });
    },
    // 添加子网保存
    addSubnet() {
      let subnetPId = undefined;
      if (this.nodes && this.nodes.length > 0) {
        subnetPId = this.nodes[0].parentid;
      }
      this.$refs.addsubnet.outputs(subnetPId, this.offsetX, this.offsetY);
    },
    cancelSubnet() {
      this.$refs.subnetDialog.clear();
      this.$refs.subnetDialog.close();
      this.$refs.addsubnet.initData();
    },
    // 修改子网保存
    update2Subnet() {
      this.$refs.updateSubnet.outputs(this.isAdd, this.offsetX, this.offsetY);
    },
    cancel2Subnet() {
      this.$refs.updateSubnetDialog.clear();
      this.$refs.updateSubnetDialog.close();
    },
    // 保存坐标
    saveLoc() {
      const nodes = diagramInstance.nodes;
      this.saveLocation(nodes, this.isLogical);
    },
    revert() {
      diagramInstance.scrollSettings.currentZoom = 1;
      diagramInstance.reset();
    },
    selectAll() {
      diagramInstance.selectAll();
    },
    async refresh(isLogical) {
      if (isLogical != undefined) {
        this.isLogical = isLogical;
      }
      try {
        this.$loading.showLoadding(this.$t("Topo.topoLoad"));
        if (this.findAlarmTimer) {
          clearTimeout(this.findAlarmTimer);
          this.findAlarmTimer = null;
        }
        this.$emit("updateTree");
        await this.loadGraph(this.isLogical);
        this.findAlarmTimer = setTimeout(this.queryAlarm, 1000);
        this.resetDiagram();
      } catch (e) {
        this.$loading.hideLoadding();
      }
    },
    excelLayout() {
      if (this.nodes.length > 0) {
        this.nodes = this.layout(this.nodes);
      }
    },
    doubleClick(args) {
      if (args.source instanceof Node) {
        const array = this.nextLayer(args, this.isLogical);

        if (this.leftDataSource && this.leftDataSource.length > 0) {
          var filterChildren = this.leftDataSource.filter(
            (x) => x.parentId == args.source.id
          );
          if (filterChildren.length == 0) {
            return;
          }
        }

        if (
          (args.source.type === 0 || args.source.type >= 10000) &&
          args.source.type !== 10004 &&
          args.source.type !== 10006 &&
          args.source.type !== 10007
        ) {
          diagramInstance.clear();
          this.nodes = array;
          if (array.length === 0) {
            this.dClickId = args.source.id;
            this.dClickPId = args.source.parentid;
          }
        } else if (array.length > 0) {
          this.nodes = array;
        }
      }
    },

    // 点击树联动拓扑图的边框样式
    receiveTree(treeId) {
      const _this = this;
      let node =
        diagramInstance.nodes[
          diagramInstance.nodes.findIndex((v) => v.id === treeId.toString())
        ];
      if (node === undefined) {
        node = this.getPhysicalById(treeId);
        const parentId = node.parentid ? node.parentid.toString() : null;
        let nodes = this.findChildren(parentId, false);
        //console.log('清空前数据diagram.nodes:', diagramInstance.nodes);
        diagramInstance.clear();
        this.nodes = [];
        nodes.forEach((element) => {
          _this.nodes.push(element);
        });
        //console.log('清空后diagram的节点:', diagramInstance.nodes);
      } else {
      }

      try {
        setTimeout(function () {
          const node =
            diagramInstance.nodes[
              diagramInstance.nodes.findIndex((v) => v.id === treeId.toString())
            ];

          if (node != null) {
            const selectNode = [];
            selectNode.push(node);
            diagramInstance.select(selectNode);
          }
        }, 20);
      } catch (e) {
        console.log(e);
      }
    },

    click(args) {
      this.seeBottom = !this.seeBottom;
      const clickNode = args.element;
      const flag = clickNode !== null && clickNode.id !== undefined;
      if (flag) {
        this.selectNodes = [];
        this.sendMessage(args.element.id);
        this.selectNodes.push(clickNode);
        diagramInstance.select(this.selectNodes);
      }
    },
    // 拖动网元边界限制
    positionChange(args) {
      if (args.source.nodes == null || args.source.nodes.length == 0) return;

      var node = args.source.nodes[0];
      if (node.useVue != null && node.useVue == "FourListLinkagePanel") {
        if (
          node.offsetX >= document.body.clientWidth - node.PositionX &&
          node.offsetY <= node.PositionY
        ) {
          this.fourListLinkagePanel.PositionXY = "left:25px";
        } else {
          this.fourListLinkagePanel.PositionXY = "right:25px";
        }
        return;
      }

      //-- ThreeListLinkagePanel, when physic view and net element is 5gc trunk
      if (node.useVue != null && node.useVue == "ThreeListLinkagePanel") {
        if (
          node.offsetX >= document.body.clientWidth - node.PositionX &&
          node.offsetY <= node.PositionY
        ) {
          this.threeListLinkagePanel.PositionXY = "left:25px";
        } else {
          this.threeListLinkagePanel.PositionXY = "right:25px";
        }
        return;
      }

      if (node.useVue != null && node.useVue == "EquipmentInfoForm") {
        if (
          node.offsetX >= document.body.clientWidth - node.PositionX &&
          node.offsetY <= node.PositionY
        ) {
          this.equipmentInfoForm.PositionXY = "left:25px";
        } else {
          this.equipmentInfoForm.PositionXY = "right:25px";
        }
        return;
      }

      //-- For example: "UNMS"
      if (node.type >= 10001 && node.type < 11000) {
        if (
          node.offsetX >= document.body.clientWidth - node.PositionX &&
          node.offsetY <= node.PositionY
        )
          this.alarmShowObj.PositionXY = "left:25px";
        else this.alarmShowObj.PositionXY = "right:25px";

        return;
      }

      //-- this is subnet
      if (Number(node.type) == 0) {
        if (
          node.offsetX >= document.body.clientWidth - node.PositionX &&
          node.offsetY <= node.PositionY
        )
          this.subnetShowObj.PositionXY = "left:25px";
        else this.subnetShowObj.PositionXY = "right:25px";

        return;
      }
    },
    backPrevious() {
      if (this.nodes.length > 0) {
        const array = this.backPre(this.nodes[0], this.isLogical);
        if (array.length > 0) {
          this.nodes = array;
        }
      } else {
        if (this.dClickPId) this.dClickPId = this.dClickPId.toString();

        const array = this.findChildren(this.dClickPId, this.isLogical);
        this.nodes = array;
      }
    },
    async getAuth2(username, netNodes) {
      //-- 获取网元权限
      //-- this is retrun result
      var resultModel = function () {
        this.success = false;
        this.admin = false;
        this.authNetId = new Array();
      };
      var result = new resultModel();
      if (netNodes == null || netNodes.length == 0) return result;

      let IsAdminRole = false;
      await this.$axios.get("/lte/ems/auth/findSystemRole").then((response) => {
        if (response && response.status === 200 && response.data !== undefined)
          IsAdminRole = response.data;
      });
      //-- admin has all Net
      if (
        username === "Eadmin" ||
        username === "unmadmin" ||
        IsAdminRole == true
      ) {
        result.success = true;
        result.admin = true;
        for (var i = 0; i < netNodes.length; i++)
          result.authNetId.push(netNodes[i].id);

        return result;
      }

      let authList = [];
      await this.$axios
        .get("/lte/ems/auth/findAuthNodeList")
        .then((response) => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            response.data.length > 0
          ) {
            response.data.forEach((element) => {
              authList.push(element.nodeId.toString());
            });
          }
        });

      let abc = netNodes;
      for (var j = 0; j < netNodes.length; j++) {
        if (netNodes[j].type == "0") {
          //-- subnet has auth
          result.success = true;
          result.authNetId.push(netNodes[j].id);
          continue;
        }

        const hasPermis = authList.find((v) => v === netNodes[j].id);
        if (hasPermis == undefined || hasPermis == null) continue;

        result.success = true;
        result.authNetId.push(netNodes[j].id);
      }

      return result;
    },
    getParentAuth(id, authList) {
      if (authList.indexOf(id) > -1) {
        return true;
      }
      const node = this.getPhysicalById(id);
      if (node) {
        const parentId = node.parentid;
        if (parentId !== null && parentId !== undefined) {
          return this.getParentAuth(parentId.toString(), authList);
        }
      }
      return false;
    },
    // 接收webSocket
    subscribeCallback(wsMessage) {
      const message = JSON.parse(wsMessage.body);
      const event = message.event; //主题事件
      const element = message.element; //id/idList
      const result = message.result; //在线状态
      if (
        event === undefined ||
        element === undefined ||
        result === undefined
      ) {
        return;
      }
      if (window.location.href.indexOf("topo/physicGraph") < 0) {
        return;
      }
      switch (event) {
        case "DPLINK_STATUS_CHANGED":
        case "CLUSTER_STATUS_CHANGED":
        case "EQUIPMENT_STATUS_CHANGED":
        case "NET_ELEMENT_STATUS_CHANGED":
          // 在线状态发送给topoTree
          this.$emit("setTreeOnline", element, result);
          // 批量处理在线状态
          if (element instanceof Array) {
            if (element.length === 0) return;
            this.setOnlineStatusForList(element, result);
          } else {
            this.setOnlineStatus(element, result);
          }
          break;
        case "ADD_SUBNET":
        case "ADD_CLUSTER":
        case "ADD_EQUIPMENT":
        case "ADD_NET_ELEMENT":
          this.addElement(JSON.parse(element));
          break;
        case "MODIFY_SUBNET":
        case "MODIFY_CLUSTER":
        case "MODIFY_EQUIPMENT":
        case "MODIFY_NET_ELEMENT":
          this.UpdateElement(JSON.parse(element));
          break;
        case "DELETE_SUBNET":
        case "DELETE_CLUSTER":
        case "DELETE_EQUIPMENT":
        case "DELETE_NET_ELEMENT":
          this.deleteElement(JSON.parse(element));
          break;
      }
    },

    // 批量在线/下线状态
    setOnlineStatusForList(idList, isOnline) {
      idList.forEach((id) => {
        this.setOnlineStatus(id, isOnline);
      });
    },

    // 单个网元在线状态
    setOnlineStatus(id, isOnline) {
      const node = this.getPhysicalById(id.toString());

      if (!node || node.isOnline === isOnline) return;

      const currentNode =
        diagramInstance.nodes[
          diagramInstance.nodes.findIndex((v) => v.id === id.toString())
        ];
      const elementShape = this.iconWithBalloon(
        node.type,
        isOnline,
        node.alarmLevel,
        node.alarmCount
      );

      // 图状态更新
      if (currentNode) {
        currentNode.isOnline = isOnline;
        currentNode.shape.content = elementShape;
        currentNode.height =
          currentNode.alarmCount && currentNode.alarmCount > 0 && isOnline
            ? this.alarmHeight
            : 58;
      }

      // vuex缓存状态
      node.isOnline = isOnline;
      node.shape.content = elementShape;

      // 通过服务判断node或集群在线状态
      if (node.type >= 30100 && node.type <= 30200) {
        const aNodeList = this.physicalNodes;
        let onlineNum = 0; // 相同node下的服务在线个数
        if (aNodeList && aNodeList.length > 0) {
          for (let i = 0; i < aNodeList.length; i++) {
            if (node.parentid == n.parentid && n.isOnline == 1) {
              onlineNum++;
              break;
            }
          }
        }
        const pNode = this.getPhysicalById(node.parentid);
        if (onlineNum === 0) {
          pNode.isOnline = 0;
        } else {
          pNode.isOnline = 1;
        }
        const pShape = this.iconWithBalloon(
          pNode.type,
          pNode.isOnline,
          pNode.alarmLevel,
          pNode.alarmCount
        );
        pNode.shape.content = pShape;
        const pCurrentNode =
          diagramInstance.nodes[
            diagramInstance.nodes.findIndex((v) => v.id === pNode.id.toString())
          ];
        if (pCurrentNode) {
          pCurrentNode.isOnline = pNode.isOnline;
          pCurrentNode.shape.content = pShape;
        }
      }
    },

    // 更改告警状态
    setAlarmStatus(id, level, count, node) {
      if (!id) return;
      if(!node) node = this.getPhysicalById(id.toString());
      if (!node || !node.isOnline) return;

      if (node.alarmLevel !== level || node.alarmCount !== count) {
        let currentNode =
          diagramInstance.nodes[
            diagramInstance.nodes.findIndex((v) => v.id === id.toString())
          ];
        // 换图标
        const shape = this.iconWithBalloon(
          node.type,
          node.isOnline,
          level,
          count
        );
        // 图状态更新
        if (currentNode) {
          currentNode.height =
            count && count > 0 && node.isOnline ? this.alarmHeight : 58;
        }

        // 图上当前网元
        if (currentNode === undefined) {
          currentNode = node;
        }
        currentNode.shape.content = shape;
        currentNode.alarmLevel = level;
        currentNode.alarmCount = count;
        // vuex中状态
        node.shape.content = shape;
        node.alarmLevel = level;
        node.alarmCount = count;
      }
    },
    // setAlarmStatus(id, level, count) {
    //   if (!id) return;

    //   const node = this.getPhysicalById(id.toString());
    //   if (!node || !node.isOnline) {
    //     return;
    //   }

    //   if (node.alarmLevel !== level || node.alarmCount !== count) {
    //     let currentNode = this.nodes.find((v) => v.id === id.toString())
    //     // 换图标
    //     const shape = this.iconWithBalloon(
    //       node.type,
    //       node.isOnline,
    //       level,
    //       count
    //     );
    //     // 图状态更新
    //     if (currentNode) {
    //       currentNode.height =
    //         count && count > 0 && node.isOnline ? this.alarmHeight : 58;
    //     }

    //     // 图上当前网元
    //     if (currentNode === undefined) {
    //       currentNode = node;
    //     }
    //     currentNode.shape.content = shape;
    //     currentNode.alarmLevel = level;
    //     currentNode.alarmCount = count;
    //     // vuex中状态
    //     node.shape.content = shape;
    //     node.alarmLevel = level;
    //     node.alarmCount = count;
    //   }
    // },

    // 添加网元websocket
    addElement(wsMessage) {
      const typeCode = wsMessage.typeCode ? wsMessage.typeCode.toString() : "0";
      const parentId = wsMessage.parentId
        ? wsMessage.parentId
        : wsMessage.clusterId
        ? wsMessage.clusterId
        : wsMessage.equipmentId
        ? wsMessage.equipmentId
        : wsMessage.subnetId
        ? wsMessage.subnetId
        : null;
      const isOnline = typeCode == 0 ? 1 : 0;
      const elementShape = this.baseIcon(typeCode, isOnline);
      const node = {
        id: wsMessage.id.toString(),
        parentid: parentId,
        type: typeCode,
        strType: this.getTypeByCode(typeCode),
        isOnline: isOnline,
        alarmStatus: -1,
        offsetX: wsMessage.positionX ? wsMessage.positionX : 226,
        offsetY: wsMessage.positionY ? wsMessage.positionY : 226,
        name: wsMessage.name,
        shape: { type: "Native", content: elementShape },
        annotations: [
          {
            // content: `${wsMessage.name}`.length > 8 ? `${wsMessage.name.substring(0, 6)}..._${wsMessage.id}` : `${wsMessage.name}_${wsMessage.id}`,
            content: `${wsMessage.name}`,
            offset: { x: 0.5, y: 1.3 },
            margin: { bottom: 10 },
            constraints: AnnotationConstraints.ReadOnly,
          },
        ],
        constraints:
          (NodeConstraints.Default &
            ~NodeConstraints.Rotate &
            ~NodeConstraints.Resize &
            ~NodeConstraints.Tooltip &
            ~NodeConstraints.InheritTooltip) |
          NodeConstraints.HideThumbs,
      };

      this.addPhysical(node);
      if (this.nodes && this.nodes.length > 0) {
        const brother = this.nodes[0];
        if (brother.parentid === parentId || (!brother.parentid && !parentId)) {
          this.nodes = diagramInstance.nodes;
          this.nodes.push(node);
        }
      } else {
        this.nodes = diagramInstance.nodes;
        this.nodes.push(node);
      }

      if (this.reflreshFlag) {
        this.reflreshFlag = false;
        this.refreshConfirm();
      }
    },

    // 修改网元的websocket
    UpdateElement(wsMessage) {
      // 过滤保存位置的websocket
      if (wsMessage.name) {
        const parentId = wsMessage.parentId
          ? wsMessage.parentId
          : wsMessage.clusterId
          ? wsMessage.clusterId
          : wsMessage.equipmentId
          ? wsMessage.equipmentId
          : wsMessage.subnetId
          ? wsMessage.subnetId
          : null;
        // 查找缓存
        const cache = this.getPhysicalById(wsMessage.id.toString());
        if (cache !== undefined) {
          if (wsMessage.typeCode >= 10000 && wsMessage.typeCode != 20001) {
            try {
              const devParentId = this.getPhysicalById(
                wsMessage.id.toString()
              ).parentid;
              if (devParentId != parentId) {
                this.refreshConfirm();
              }
            } catch (e) {
              console.log("设备刷新异常");
            }
          }
          if (cache.name !== wsMessage.name) {
            cache.name = wsMessage.name;
            cache.annotations[0].content = `${wsMessage.name}`;
          }
          if (cache.parentid !== parentId) {
            cache.parentid = parentId;
          }
          // 当前层是否有该网元
          const graphNode =
            diagramInstance.nodes[
              diagramInstance.nodes.findIndex(
                (v) => v.id === wsMessage.id.toString()
              )
            ];
          if (graphNode !== undefined) {
            graphNode.name = wsMessage.name;
            graphNode.annotations[0].content = `${wsMessage.name}`;
            graphNode.parentid = parentId;
          }
        }
        if (!wsMessage.typeCode) {
          this.refreshConfirm();
        } else {
          this.$emit("updateTree");
        }
      }
    },
    // websocket公用删除方法
    deleteElement(element) {
      const id = element.id.toString();
      const node =
        diagramInstance.nodes[
          diagramInstance.nodes.findIndex((v) => v.id === id)
        ];
      if (node) {
        diagramInstance.remove(node);
      }
      // 删除缓存
      this.delPhysicalNodes(element.id.toString());
      this.nodes = diagramInstance.nodes;
      if (!element.typeCode) {
        this.refreshConfirm();
      }
      this.$emit("updateTree");
    },
    refreshConfirm() {
      if (window.location.href.indexOf("topo/physicGraph") < 0) return;

      this.$layer.confirm({
        msg: this.$t("Topo.refresh"),
        btn1: {
          msg: this.$t("System.confirm"),
          func: this.refreshNodes,
        },
      });
    },
    refreshNodes() {
      diagramInstance.clear();
      this.nodes = [];
      this.loadGraph(this.isLogical);
      this.reflreshFlag = true;
      this.$emit("updateTree");
      this.resetDiagram();
    },
    // 告警信息查询api
    queryAlarmApi() {
      return new Promise((resolve, reject) => {
        const userId = this.getUserId();
        if(userId) {
          this.axios.post(
            "/lte/ems/topo/ne/findNeAlarm/" + userId + "/" + this.isLogical,
            this.roleNe
          ).then(response => {
            if (
              response &&
              response.status === 200 &&
              response.data.errorCode === "SUCCESS"
            ) {
              // 存放告警数据
              this.alarmMap.clear()
              response.data.resultVal.forEach((alarm) => {
                this.alarmMap.set(alarm.neId.toString(), alarm);
              });
              resolve(response);
            } else {
              reject({status: -1, msg: 'findNeAlarm接口获取数据失败'});
            }
          })
        } else {
          reject({status: -1, msg: 'userID未获取到'});
        }
      });
    },
    // 轮询查告警
    queryAlarm() {
      if(!this.getUserId()) return;
      this.queryAlarmApi().then((response) => {
        const result = response.data.resultVal;
        const physicalNodes = this.physicalNodes;
        if (!result || result.length === 0) {
          // 当有告警，转成无告警时，返回数据：{"errorCode":"SUCCESS","errorString":null,"errorParams":null,"resultVal":[]}
          if (physicalNodes && physicalNodes.size > 0) {
            physicalNodes.forEach((node, key) => {
              this.setAlarmStatus(node.id, -1, 0);
            });
          }
          this.$loading.hideLoadding();
          return;
        }

        if (physicalNodes && physicalNodes.size > 0) {
          physicalNodes.forEach((node, key) => {
            const id = node.id;
            const currentAlarmItem = this.alarmMap.get(id);
            if (currentAlarmItem) {
              this.setAlarmStatus(id, currentAlarmItem.level, currentAlarmItem.count);
            } else {
              this.setAlarmStatus(id, -1, 0);
            }
          });
        }
        this.$loading.hideLoadding();
      }).catch((e) => {
        console.log('查询失败-e:', e)
      });
    },
    resetDiagram() {
      try {
        const diagramStr = diagramInstance.saveDiagram();
        const diagramJson = JSON.parse(diagramStr);
        const diagramJsonNodes = diagramJson.nodes;
        for (let diagramNode of diagramJsonNodes) {
          for (let nodesItem of this.nodes) {
            if (diagramNode.id == nodesItem.id) {
              diagramNode.alarmCount = nodesItem.alarmCount;
              diagramNode.alarmLevel = nodesItem.alarmLevel;
              diagramNode.isOnline = nodesItem.isOnline;
              diagramNode.name = nodesItem.name;
              diagramNode.parentid = nodesItem.parentid;
              diagramNode.strType = nodesItem.strType;
              diagramNode.type = nodesItem.type;
            }
          }

        }
        diagramInstance.clear();
        diagramInstance.loadDiagram(JSON.stringify(diagramJson));
        const selectArray = [];
        if (this.selectNodes.length > 0) {
          this.selectNodes.forEach((element) => {
            selectArray.push(element);
          });
          diagramInstance.select(selectArray);
        }
      } catch (e) {
        console.log("复位操作错误...e:", e);
      }
    },
    getUserId() {
     const user = JSON.parse(sessionStorage.getItem("principal"));

     if(!(user && user.userId)){

        this.$axios.get('/lte/security/findSecuritySubject', {}).then((res) => {
              if(res.status==200) {
                if (!!res.data) {
                  sessionStorage.setItem('principal', JSON.stringify(res.data));
                }
              }
        });

     }


     return user && user.userId;
    }
  },
};
</script>
